module.exports = __webpack_public_path__ + "static/award5-fa2a56ff62f33f1d03c98d0950fa9a50.png";